'use client'

import React, { createContext, useContext, useState, ReactNode } from 'react';
import './sideBar.scss';
import { TimesIcon } from '@/icons';

interface SidebarContextProps {
  openSidebar: (
    id: string,
    title: string,
    direction: 'left' | 'right',
    content: ReactNode,
  ) => void;
  closeSidebar: () => void;
}

const SidebarContext = createContext<SidebarContextProps | undefined>(
  undefined,
);

export const SidebarProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [direction, setDirection] = useState<'left' | 'right'>('left');
  const [content, setContent] = useState<ReactNode | null>(null);
  const [currentSideBarId, setIsCurrentSideBarId] = useState<string>('');
  const [title, setTitle] = useState('');

  const openSidebar = (
    id: string,
    title: string,
    dir: 'left' | 'right',
    newContent: ReactNode,
  ) => {
    if (currentSideBarId === id) {
      closeSidebar();
      return;
    }
    if (isOpen) {
      closeSidebar();
    }
    setTitle(title);
    setContent(newContent);
    setIsCurrentSideBarId(id);
    setDirection(dir);
    setTimeout(() => {
      setIsOpen(true);
    }, 100);
  };

  const closeSidebar = () => {
    setIsOpen(false);
    setIsCurrentSideBarId('');
    setContent(null);
    setDirection(direction);
  };

  return (
    <SidebarContext.Provider value={{ openSidebar, closeSidebar }}>
      {children}
      {/* SidePanel burada kullanılıyor */}
      <div className={`sidePanel ${isOpen ? 'open' : ''} ${direction}`}>
        <div className="sidePanel-header">
          <span>{title}</span>
          <button
            className="obro-transparent-btn"
            onClick={() => closeSidebar()}
          >
            <TimesIcon className={undefined} />
          </button>
        </div>
        {content}
      </div>
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context)
    throw new Error('useSidebar must be used within a SidebarProvider');
  return context;
};
